// extracted by mini-css-extract-plugin
export default {"inputBox":"LgbtInputBox_inputBox__pc0O7","inputField":"LgbtInputBox_inputField__5zFmd"};